import React from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useInView, reveal } from './motion';
import { useT } from '../../i18n/LanguageContext';

import { BOOK_URL } from '../../config';

const book = require('../../assets/img/Libro.png');

export default function MethodBook() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { ref, visible } = useInView();
  const t = useT();

  return (
    <Box sx={{ bgcolor: theme.home.paperDeep, py: theme.home.sectionPy, position: 'relative', overflow: 'hidden' }}>
      <Box
        ref={ref}
        sx={{
          maxWidth: theme.home.maxWidth, mx: 'auto', px: { xs: 3, md: 5 },
          display: 'grid', gridTemplateColumns: { xs: '1fr', md: '0.9fr 1.1fr' }, gap: { xs: 6, md: 8 }, alignItems: 'center',
        }}>
        <Box sx={{ position: 'relative', textAlign: 'center', ...reveal(visible) }}>
          <Box sx={{
            position: 'absolute', inset: '8% 14%', borderRadius: 4,
            background: `linear-gradient(135deg, ${theme.home.cyan}33, ${theme.home.coral}33)`, transform: 'rotate(-4deg)',
          }} />
          <Box component="img" src={book} alt={t('home.methodBook.imgAlt')}
            sx={{ position: 'relative', width: '100%', maxWidth: 360, mx: 'auto', filter: 'drop-shadow(0 30px 50px rgba(20,24,29,0.35))' }} />
        </Box>

        {/* Copy */}
        <Box>
          <Typography variant="overline" sx={{ color: theme.home.coralText, ...reveal(visible, 0.05) }}>
            {t('home.methodBook.eyebrow')}
          </Typography>
          <Typography variant="h2" sx={{ mt: 1.5, fontSize: { xs: '2rem', md: '2.7rem' }, color: theme.home.ink, ...reveal(visible, 0.1) }}>
            {t('home.methodBook.title')}
          </Typography>
          <Typography sx={{ mt: 2.5, color: theme.home.inkMuted, fontSize: '1.12rem', lineHeight: 1.7, maxWidth: 520, ...reveal(visible, 0.16) }}>
            {t('home.methodBook.bodyPre')} <em>Sinergie Generative</em> {t('home.methodBook.bodyPost')}
          </Typography>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mt: 4, ...reveal(visible, 0.22) }}>
            <Button
              variant="contained" size="large" href={BOOK_URL} target="_blank" rel="noopener noreferrer"
              sx={{ px: 3.5, py: 1.4, borderRadius: 999, bgcolor: theme.home.ink, '&:hover': { bgcolor: theme.home.inkHover }, boxShadow: theme.home.cardShadow }}
            >
              {t('home.methodBook.ctaBuy')}
            </Button>
            <Button
              variant="outlined" size="large" onClick={() => navigate('/redeem')}
              sx={{ px: 3.5, py: 1.4, borderRadius: 999, borderColor: theme.home.ink, color: theme.home.ink,
                '&:hover': { borderColor: theme.home.ink, bgcolor: 'rgba(20,24,29,0.04)' } }}
            >
              {t('home.methodBook.ctaRedeem')}
            </Button>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
}
